import script from "./BuildingTableView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuildingTableView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__